import dayjs from "dayjs"

export const isSubTaskMeetingPushed = subTask => {
  return subTask === "meeting_pushed"
}

export const isSubTaskMeetingRescheduled = subTask => {
  return subTask === "meeting_rescheduled"
}

export function computeDeadline({ subTask, meetingTime, salesEvent, taskTypes }) {
  if (!meetingTime) return {}
  const now = dayjs()
  const eventTime = dayjs(meetingTime)
  const isToday = eventTime.isSame(now, "day")
  const isAfterToday = eventTime.isAfter(now, "day")
  let deadline = null
  const todoLogic = taskTypes?.todoLogic?.[subTask]
  if (!todoLogic?.logicType) {
    if (subTask === "meeting_pushed") {
      if ((isToday && salesEvent) || isToday) {
        deadline = eventTime.subtract(1, "hour")
      } else if (isAfterToday && !salesEvent) {
        deadline = eventTime.subtract(2, "hour")
      } else if (isAfterToday && salesEvent) {
        deadline = eventTime.hour(9).minute(0).second(0)
      }
      return deadline
    } else {
      return dayjs().add(3, "days")
    }
  } else return deadline
}
